/*
 * @ Author: wangjiyu
 * @Date: 2019-10-30 13:58:00
 * @LastEditTime: 2019-10-30 14:09:13
 * @Description: file content
 */
import Vue from 'vue';
import Main from './main.vue';

const MessageConstructor = Vue.extend(Main);

let instance;
const Message = options => {
    instance = new MessageConstructor({
        data: options
    });

    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
    instance.vm.show = true;
    return instance.vm;
};

['info', 'success', 'error'].forEach(type => {
    Message[type] = message =>
        Message({
            type,
            message
        });
});

export default {
    info: Message.info,
    success: Message.success,
    error: Message.error,
    message: Message
};
